<template>
  <div class="shape">
    <div class="bottomViolet">
      <div class="columns is-paddingless is-marginless level">
        <div class="level-left is-marginless is-paddingless is-12">
          <div v-if="dataInfoOpp.urlLogo">
            <figure class="rightVert">
              <img :src="dataInfoOpp.urlLogo" class="logo" alt="">
            </figure>
          </div>
          <div class="column is-paddingless">
            <h1 class="has-text-link has-text-weight-bold">
              {{dataInfoOpp.nomCommercial}}
            </h1>
            <h3 class="has-text-secondary-icon has-text-weight-bold">
              {{dataInfoOpp.themeCampagne}}
            </h3>
            <p class="has-text-default p_size12">{{dateValidite}}</p>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { formatDate } from '@/services/opportunite/formatTab';

export default {
  name: 'infoOpp',
  props: ['dataInfoOpp'],
  computed: {
    dateValidite() {
      return formatDate(this.dataInfoOpp.dateCreation);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/composants/infoOpp.vue